import { container } from "tsyringe";

import type { LoaderUserActionPreventionPredicate } from '#/CoreFrameInterfaces';

export interface ILoader {
    init(): void;

    /**
     * Registriert ein Predicate, welches entscheidet, ob eine UserAction während eines Loaders verhindert werden soll
     * Predicate gibt true zurück -> Action wird verhindert, Predicate gibt false zurück -> Action wird nicht verhindert
     * @param predicate
     */
    registerPreventUserActionsException(predicate: LoaderUserActionPreventionPredicate): void;

    while(element: JQuery | null, callback: Function): void;

    show($element?: JQuery, showLoader?: boolean, showOverlay?: boolean): void;

    hideAsync(element?: JQuery, delay?: number): Promise<boolean>;

    hide(element?: JQuery, delay?: number): void;

    removeAll(): void;
}

export default class Loader {
    public static getInstance(): ILoader {
        return container.resolve<ILoader>("Loader");
    }
}